module.exports = __webpack_public_path__ + "static/media/me3_ECAP_Classes_Icon.f2060c46.svg";